import 'bootstrap-less/bootstrap/bootstrap.less';
import 'slick-carousel/slick/slick.less';
import 'angularjs-toaster/toaster.scss';
import 'ngprogress-lite/ngprogress-lite.css';

import angular from 'angular';
import 'lodash';

import 'slick-carousel';
import 'angular-google-chart';
import 'angular-google-maps';
import 'angular-simple-logger/dist/angular-simple-logger.light.min';
import 'angular-slick-carousel';
import 'angular-sticky-plugin';
import './ace-imports'; // pouzito ve kp-file-editor (media viewer)
import 'angular-ui-ace'; // pouzito ve kp-file-editor (media viewer)
import 'ng-clamp1'; // used in OPAC_RECORD -> TemplateRecordCarousel
import angularUiBootstrap from '@kpsys/angular-ui-bootstrap';
import toaster from 'angularjs-toaster';
import ngProgressLite from 'ngprogress-lite';
import register from '@kpsys/angularjs-register';
import inView from 'angular-inview'; // used in kp-pdf-viewer
import ngAnimate from 'angular-animate';
import ngResource from 'angular-resource'; // used in tender module
import ngSanitize from 'angular-sanitize';
import {DateTime, Settings} from 'luxon';
import uiRouter from '@uirouter/angularjs';
import restangular from 'restangular';
import {initUrlUtilsHelper} from 'shared/utils/url-utils';
import {initNgDecoratorsHelper} from 'shared/utils/ng-@decorators';
import {
    getRecordPath,
    getRecordUrlId,
    defaultIdMapper
} from 'shared/utils/data-service-utils';
import {LOG_LEVELS} from './commons/decorators/log.decorator';

import directivesModule from './commons/directives/directives.module';
import componentsModule from './commons/components/components.module';
import filtersModule from './commons/filters/filters.module';
import providersModule from './commons/providers/providers.module';
import servicesModule from './commons/services/services.module';
import dataServiceModule from './commons/data-services/data-services.module';
import decoratorsModule from './commons/decorators/decorators.module';

import mainMenuConfig from './commons/config/main-menu.config';
import searchInputConfig from './commons/config/search-input.config';

import mainConfigurationModule from './commons/main-configuration/main-configuration.module';
import searchModule from './search/search.module';
import conversationModule from './commons/conversation/conversation.module';
import loginModule from './login/login.module';
import editationModule from './editation/record-editation.module';
import barcodeScannerModule from './barcode-scanner/barcode-scanner.module';
import fileModule from './file/file.module'
import loanCategoriesModule from './loan/loan-categories/loan-categories.module';
import exemplarStatusModule from './exemplar-status/exemplar-statuses.module';
// UCs
import acquisitionModule from './use-cases/acquisition/acquisition.module';
import changelogModule from './use-cases/changelog/changelog.module';
import favouritesModule from './use-cases/favourites/favourites.module';
import fondsModule from './use-cases/fonds/fonds.module';
import homeModule from './use-cases/home/home.module';
import inventoryModule from './inventory/inventory.module';
import thesaurusModule from './use-cases/thesaurus/thesaurus.module';
import usersModule from './use-cases/users/users.module';
import users2Module from './user/user.module';
import recordModule from './record/record.module';
import mediaViewerModule from './media-viewer/media-viewer.module';
import sdiRequestsModule from './use-cases/sdi-requests/sdi-requests.module';
import settingsModule from './use-cases/settings/settings.module';
import utilsModule from './util/utils.module';
import provenioModule from './use-cases/provenio/provenio.module';
import loansModule from './use-cases/loans/loans.module';
import reportServerModule from './use-cases/report-server/report-server.module';
import messagesModule from './use-cases/messages/messages.module';
import localizationModule from './localizations/localizations.module';
import svelteModule from './svelte/svelte.module';
import svelteTestModule from './svelte/svelte-test.module';
import pageModule from './page/page.module';

import ModalConversationInterceptorService from './commons/services/modal-conversation-interceptor.service';

import '../styles/default.less';
import KpCover from './record/kp-cover/KpCover.svelte';
import KpAvailabilityInfo from './record/kp-availability-info/KpAvailabilityInfo.svelte';
import KpFavouritesButton from './commons/components/kp-favourites-button/KpFavouritesButton.svelte';
import KpRecordClipboardButton
    from './commons/components/record-clipboard/kp-record-clipboard-button/KpRecordClipboardButton.svelte';
import {getFirstByProperty} from 'shared/utils/array-utils.fp';
import {LoanInterceptorRegistrar} from './loan/loan.interceptor-registrar';
import departmentsModule from './departments/departments.module';
import filtersPageModule from './filters/filters-page.module';
import locationsModule from './locations/locations.module';
import facetTypesModule from './facet-types/facet-types.module';
import recordExportModule from './record-exports/record-export.module';
import valueEditorsModule from './commons/value-editors/value-editors.portaro.module'
import statsModule from './stats/stats.module';
import {clientSideBotDetection} from './portaro.config';
import verbisboxModule from './verbisbox/verbisbox.module';
import customElementsModule from './custom-elements/custom-elements.module'
// Set default locale
Settings.defaultLocale = DateTime.local().resolvedLocaleOptions().locale;

/**
 * @ngdoc module
 * @name portaro
 * @module portaro
 */
const portaro = register('portaro', [
    'ui.ace',
    'uiGmapgoogle-maps',
    'googlechart',
    'slickCarousel',
    'ng-clamp',
    'hl.sticky',
    ngResource,
    ngSanitize,
    angularUiBootstrap,
    inView,
    ngAnimate,
    restangular,
    uiRouter,
    toaster,
    ngProgressLite,

    directivesModule,
    componentsModule,
    providersModule,
    servicesModule,
    dataServiceModule,
    decoratorsModule,
    filtersModule,
    barcodeScannerModule,
    pageModule,

    mainConfigurationModule,
    conversationModule,
    loginModule,
    searchModule,
    loanCategoriesModule,
    departmentsModule,
    filtersPageModule,
    exemplarStatusModule,
    locationsModule,
    facetTypesModule,
    recordExportModule,

    acquisitionModule,
    changelogModule,
    homeModule,
    thesaurusModule,
    usersModule,
    users2Module,
    recordModule,
    favouritesModule,
    fondsModule,
    inventoryModule,
    mediaViewerModule,
    sdiRequestsModule,
    editationModule,
    settingsModule,
    utilsModule,
    provenioModule,
    loansModule,
    messagesModule,
    reportServerModule,
    localizationModule,
    fileModule,
    svelteModule,
    svelteTestModule,
    valueEditorsModule,
    statsModule,
    verbisboxModule,
    customElementsModule,
])
    .constant('portaroVersion', portaroVersion)
    .constant('CONTEXT_PATH', contextPath)
    .constant('API_BASE_URL', window.apiBaseUrl)
    .constant('SERVER_URL', serverUrl)
    .constant('TEMPLATES_PATH', contextPath + "/angular-templates/")
    .constant('CAMERA_SCANNER_ENABLED', window.portaroConfiguration.cameraScannerEnabled)
    .constant('GLOBAL_SEARCH_INPUT_ENABLED', window.portaroConfiguration.globalSearchInputEnabled)
    .constant('GOOGLE_API_KEY', 'AIzaSyCS-ou7tCwrqYhgSN38OpLtPQRDhU_UEMY')
    .config(mainMenuConfig)
    .config(searchInputConfig)
    .config(/*@ngInject*/ ($animateProvider) => $animateProvider.classNameFilter(/ng-animate-enabled/))
    .config(/*@ngInject*/ ($parseProvider) => $parseProvider.addLiteral('Infinity', Number.POSITIVE_INFINITY))
    .config(/*@ngInject*/ ($httpProvider) => $httpProvider.interceptors.push(ModalConversationInterceptorService.serviceName))
    .config(/*@ngInject*/ ($httpProvider) => {
        $httpProvider.defaults.cache = false;
        Object.assign($httpProvider.defaults.headers, {get: {'If-Modified-Since': 0}})
    })
    .config(/*@ngInject*/ ($urlRouterProvider, CONTEXT_PATH) => $urlRouterProvider.otherwise(() => {
        const replacingRegex = /(\/+$)/;
        const trimmedCurrentUrl = window.location.pathname.replace(replacingRegex, '');
        const trimmedServerUrl = CONTEXT_PATH.replace(replacingRegex, '');

        if (trimmedCurrentUrl === trimmedServerUrl) {
            return '/';
        }
    }))
    .config(/*@ngInject*/ (uiGmapGoogleMapApiProvider, GOOGLE_API_KEY) => uiGmapGoogleMapApiProvider.configure({
        key: GOOGLE_API_KEY,
        v: '3.20',
        libraries: ''
    }))
    .config(/*@ngInject*/ (RestangularProvider, observableAjaxServiceProvider, API_BASE_URL) => {
        if (API_BASE_URL) {
            RestangularProvider.setBaseUrl(API_BASE_URL);
            observableAjaxServiceProvider.setBaseUrl(API_BASE_URL);
        }

        // For sending of empty body in Remove request in UserBilanceApi
        RestangularProvider.setRequestInterceptor((elem, operation) => operation === 'remove' ? undefined : elem);
    })
    .run(initUrlUtilsHelper)
    .run(initNgDecoratorsHelper)
    .run(/*@ngInject*/ (urlStateManagerService) => {/* to bootstrap urlStateManagerService just before $locationChangeSuccess event fired */
    })
    .run(/*@ngInject*/ ($log) => $log.setLoggingLevel(LOG_LEVELS[portaroConfiguration.loggingLevel] || 0))
    .run(clientSideBotDetection)
    .module();

portaro.controller('SearchedDocumentCtrl', ['$scope', '$timeout', 'CONTEXT_PATH', 'TEMPLATES_PATH', 'currentAuthService', 'reloader', 'recordClipboardService', 'loanRequestService', 'currentAuth', 'availabilityDataService', 'loginService', 'finishedResponseInteractionService', 'recordService', 'modalConversationInterceptor', 'localizationService',
    function($scope, $timeout, CONTEXT_PATH, TEMPLATES_PATH, currentAuthService, reloader, recordClipboardService, loanRequestService, currentAuth, availabilityDataService, loginService, finishedResponseInteractionService, /*RecordService*/ recordService, /* ModalConversationInterceptorService */ modalConversationInterceptor, /* LocalizationService */ localizationService) {

        $scope.TEMPLATES_PATH = TEMPLATES_PATH;
        $scope.currentAuthService = currentAuthService;
        $scope.recordClipboardService = recordClipboardService;
        $scope.currentAuth = currentAuth;
        $scope.kpCoverComponent = KpCover;
        $scope.kpAvailabilityInfoComponent = KpAvailabilityInfo;
        $scope.kpFavouritesButtonComponent = KpFavouritesButton;
        $scope.kpRecordClipboardButtonComponent = KpRecordClipboardButton;

        $scope.init = function(record, group) {
            $scope.record = record;

            $timeout(angular.noop, Math.random() * 2000) // wait for 0 - 2000 ms before making request (used to throttle number of concurrent requests)
                .then(() => availabilityDataService.getByDocumentAndRequester($scope.record, currentAuth.activeUser.id))
                .then((av) => {
                    $scope.availability = av;
                    record.availability = av;
                    $scope.isOrderable = !!getFirstByProperty('name', 'standardOrderability')(record.availability.capabilities);
                    return av;
                });
            $scope.documentLink = createRecordLink($scope.record, group, window.location);
            new LoanInterceptorRegistrar(modalConversationInterceptor, localizationService).register();
        };

        function createRecordLink(record, group, location) {
            const recordId = getRecordUrlId(record);
            let s = `${getRecordPath(recordId)}?back=${encodeURIComponent(location.href)}`;
            if (group && group.length <= 100) { // 100 is limit due to max request size
                s += `&group=${group.map((item) => defaultIdMapper(item)).join(",")}`;
            }
            return s;
        }

        $scope.requestDocument = async function() {
            try {
                const actionResponse = await loanRequestService.requestDocument($scope.record);
                await finishedResponseInteractionService.showSuccessResponseInToastIfPossible(actionResponse);
            } catch (exceptionResponse) {
                await finishedResponseInteractionService.showFailedResponseInModalWindow(exceptionResponse);
            } finally {
                loginService.reloadIfChangedButNotReloaded();
            }
        };

        $scope.mergeToThis = async function (sources) {
            try {
                await recordService.mergeRecordsAndReload($scope.record, sources);
            } catch (exceptionResponse) {
                await finishedResponseInteractionService.showFailedResponseInModalWindow(exceptionResponse);
            }
        };

    }]);

portaro.controller('SearchedAuthorityCtrl', ['$scope', 'CONTEXT_PATH', 'TEMPLATES_PATH', '$sce', 'recordDataService', 'recordClipboardService', 'recordService', 'finishedResponseInteractionService', 'currentAuth',
    function($scope, CONTEXT_PATH, TEMPLATES_PATH, $sce, recordDataService, recordClipboardService, recordService, finishedResponseInteractionService, currentAuth) {

        $scope.TEMPLATES_PATH = TEMPLATES_PATH;
        $scope.recordClipboardService = recordClipboardService;
        $scope.$sce = $sce;
        $scope.kpRecordClipboardButtonComponent = KpRecordClipboardButton;
        $scope.kpCoverComponent = KpCover;
        $scope.currentAuth = currentAuth;

        $scope.getRecordLink = (id) => `${CONTEXT_PATH}/records/${id}`;

        $scope.init = function(record) {
            $scope.record = record;

            recordDataService.getRelatedRecordsCount(record.id)
                .then(response => $scope.relatedRecordsCount = response.value);
        };

        $scope.mergeToThis = async function (sources) {
            try {
                await recordService.mergeRecordsAndReload($scope.record, sources);
            } catch (exceptionResponse) {
                await finishedResponseInteractionService.showFailedResponseInModalWindow(exceptionResponse);
            }
        };

    }]);

export default portaro;
